<template>
    <button v-if="firstStage" @click="firstClick" :class="firstClass" :disabled="disabled">
        <slot name="firstClick"></slot>
    </button>
    <LoadingButton v-else @click="secondClick" :class="secondClass" :disabled="disabled" :is-loading="showSpinner">
        <slot name="secondClick"></slot>
    </LoadingButton>
</template>

<script>
    import LoadingButton from "./LoadingButton";

    export default {
        name: "confirm-button",
        components: { LoadingButton },
        inheritAttrs: false,
        props: ["firstClass", "secondClass", "disabled"],
        data() {
            return {
                firstStage: true,
                showSpinner: false,
            };
        },
        mounted() {
            this.firstStage = true;
        },
        methods: {
            reset() {
                this.firstStage = true;
                this.showSpinner = false;
            },
            firstClick() {
                this.firstStage = false;
            },
            secondClick() {
                this.$emit("click");
                this.showSpinner = true;
            },
        },
    };
</script>

<style scoped></style>
